import script from "./google-material-icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./google-material-icon.vue?vue&type=script&lang=ts&setup=true"

import "./google-material-icon.vue?vue&type=style&index=0&id=1eef12ed&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eef12ed"]])

export default __exports__